export class SearchCondition {
  sheet_code: string = ""
  nendo: string = ""
  report_no: string = ""
  subject_code: string = null
  status: string = ""
  qr_code: string = ""
  sheet_type: number | string = ""
  page: number = 1
  row_count: number =  50
  currentPage: number = 1
}

export class CopyBaseSheetSearchCondition {
  sheet_code: string = ""
  nendo: string = ""
  report_no: string = ""
  subject_code: string = ""
  page: number = 1
  row_count: number =  20
  currentPage: number = 1
  dst_base_sheet_id: number = null
}

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: number
  report_no: number
  name: string
  subject_code: string
  subject_name: string
  qr_code: string
  sheet_type: number
  field_names_completed: boolean
  corretct_image_completed: boolean
  field_positions_completed: boolean
  score_positions_completed: boolean
  field_names_completed_text: string
  corretct_image_completed_text: string
  field_positions_completed_text: string
  score_positions_completed_text: string
  is_checked: boolean = false
  is_completed: boolean


  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.nendo = base_sheet.nendo;
    this.report_no = base_sheet.report_no;
    this.name = base_sheet.name;
    this.subject_code = base_sheet.subject_code;
    this.subject_name = base_sheet.subject_name;
    this.qr_code = base_sheet.qr_code;
    this.sheet_type = base_sheet.sheet_type;
    this.field_names_completed = base_sheet.field_names_completed;
    this.corretct_image_completed = base_sheet.corretct_image_completed;
    this.field_positions_completed = base_sheet.field_positions_completed;
    this.score_positions_completed = base_sheet.score_positions_completed;
    this.field_names_completed_text = base_sheet.field_names_completed ? "○" : "-";
    this.corretct_image_completed_text = base_sheet.corretct_image_completed ? "○" : "-";
    this.field_positions_completed_text = base_sheet.field_positions_completed ? "○" : "-";
    this.score_positions_completed_text = base_sheet.score_positions_completed ? "○" : "-";
    this.is_completed = this.field_names_completed && this.corretct_image_completed && this.field_positions_completed && this.score_positions_completed;
  }
}
